<template>
  <div
    class="ps-absolute ps-bottom-0 ps-left-0 ps-w-full ps-text-center ps-overflow-visible"
  >
    <transition-group name="slide">
      <the-toast v-for="t in toasts" :key="t.toast_id" :toast="t" />
    </transition-group>
    <div class="ps-h-32"></div>
  </div>
</template>

<script>
import { mapState } from '@picnic-software/vuex'
import TheToast from '@/components/TheToast'

export default {
  name: 'AppToaster',
  components: {
    TheToast
  },
  computed: {
    ...mapState({
      toasts: state => state.toasts.all
    })
  }
}
</script>

<style lang="postcss">
.slide-enter-active,
.slide-leave-active {
  transition: opacity 0.5s ease;
}
.slide-enter /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.slide-leave-to {
  opacity: 0;
  transform: transformY(200%) !important;
}
</style>
